<template>
  <div
    class="absolute left-0 right-0 z-10 flex items-center pointer-events-none"
    :style="{ top: `${offset}px` }"
  >
    <div class="w-2.5 h-2.5 rounded-full bg-red-500 flex-shrink-0 -ml-1.5"></div>
    <div class="flex-1 border-t border-red-500"></div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useCalendarSettingsStore } from 'stores/calendarSettings.js'

const ROW_HEIGHT    = 64
const settingsStore = useCalendarSettingsStore()

// Tick every minute so the line advances in real time
const now = ref(new Date())
let timer = null
onMounted(()  => { timer = setInterval(() => { now.value = new Date() }, 60000) })
onUnmounted(() => clearInterval(timer))

// Reactive to both time ticks and timezone changes
const offset = computed(() => {
  const tz = settingsStore.date_primary_timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz, hour: 'numeric', minute: 'numeric', hour12: false,
    }).formatToParts(now.value)
    const h = parseInt(parts.find(p => p.type === 'hour').value) % 24
    const m = parseInt(parts.find(p => p.type === 'minute').value)
    return ((h * 60 + m) / (24 * 60)) * (24 * ROW_HEIGHT)
  } catch {
    return ((now.value.getHours() * 60 + now.value.getMinutes()) / (24 * 60)) * (24 * ROW_HEIGHT)
  }
})
</script>
